// extracted by mini-css-extract-plugin
module.exports = {"styledDraggableRow":"vpQJOeD8","isTopOver":"BXjdmJ2u","isBottomOver":"_BNNHvWa","cellContentWrapper":"cs9aILs2","dragIcon":"RiiX6mZ2","styledTableCell":"rQMmkxit"};